// Interfaces
import { ICitActivity } from "@/Common/types/ContractsInTransit/model";
import { IContentInformation } from "./interfaces";
import { ICitContentDetails } from "./CitContentDetails/interfaces";
import { isParentActivity } from "@/DataPages/helpers/financeManagement/cit/citTable";

// Constants
const ACTIVITY_TYPES = {
	RESERVES: "Finance Reserve",
	CIT: "CIT",
} as const;

const RECOMMENDED_ACTIONS = {
	CLEARING: "Recommended for Clearing",
	REVIEWING: "Consider Reviewing",
} as const;

const tabs: IContentInformation[] = [
	{
		key: "reserves",
		label: "Finance Reserves",
		hierarchyKey: "reservesHierarchy",
		activityType: ACTIVITY_TYPES.RESERVES,
		format: "itemized",
		disabled: false,
		excludedExport: false,
		activitiesIds: [],
	},
	{
		key: "cit",
		label: "Contracts in Transit",
		hierarchyKey: "hierarchy",
		activityType: ACTIVITY_TYPES.CIT,
		format: "itemized",
		disabled: false,
		excludedExport: true,
		activitiesIds: [],
	},
];

const getFilteredActivities = (activities: ICitActivity[], value: string, filteredBy: string) => {
	return activities.filter((activity) => activity?.[filteredBy as keyof ICitActivity] === value);
};

const getOptionsDetails = (activities: ICitActivity[]) => {
	return tabs.map((option) => {
		const activitiesIds = activities
			.filter((activity) => {
				const hierarchy = option.hierarchyKey;
				const isParent = isParentActivity(activity, hierarchy);
				return (
					activity.activityType === option.activityType &&
					activity.recommendedAction === RECOMMENDED_ACTIONS.CLEARING &&
					isParent &&
					!activity.exported
				);
			})
			.map((activity) => activity._id);
		return { ...option, activitiesIds };
	});
};

const getExportableDetails = (options: IContentInformation[] = []): ICitContentDetails[] => {
	const exportableOptions = options.filter((option) => !option.excludedExport && Boolean(option?.activitiesIds?.length));
	return exportableOptions.map((option: IContentInformation) => ({
		activityType: option.activityType,
		format: option.format,
		activitiesIds: option.activitiesIds ?? [],
	}));
};

export { ACTIVITY_TYPES, RECOMMENDED_ACTIONS, getExportableDetails, getFilteredActivities, getOptionsDetails };
